import VideoJsAdapter from "../../../adapters/videojs_adapter";
import Button from "../../button";

export default class Index extends Button {

  constructor(player, options = {}){
    super(player, options);
  }

  buildCSSClass() {
    return `vjs-cinema-mode-button ${super.buildCSSClass()}`;
  }

  handleClick() {
    var articlePlayer = document.getElementById('article-player');
    if (articlePlayer.className.indexOf('cinema-mode') > -1 ) {
      articlePlayer.classList.remove('cinema-mode');
    } else {
      this.triggerClick();
      articlePlayer.classList.add('cinema-mode');
    }

  }

  triggerClick(){
    this.player().trigger({ type: "vp-cinema-mode", id: this.options_.videoId });
  }
}

Index.prototype.controlText_ = "Cinema Mode";
VideoJsAdapter.registerComponent('VpCinemaModeButton', Index);
